module.exports = __webpack_public_path__ + "media/images/svg/cross-6dbbd685e32b8db243d091a7b4f360e6.svg";